import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/common/alert.service';
import { LoginService } from '../login/login.service';
import { first } from 'rxjs';
import { StorageKey, StorageService } from 'src/app/services/common/storage.service';

@Component({
  selector: 'app-approve-business-user',
  templateUrl: './approve-business-user.component.html',
  styleUrls: ['./approve-business-user.component.scss']
})
export class ApproveBusinessuserCampaignComponent implements OnInit {

  queryString = Object();

  model: any;
  constructor(private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private storageService: StorageService,
    private loginService: LoginService,) { }

  ngOnInit() {
    this.queryString = this.activatedRoute.snapshot.queryParams;

    if (this.queryString?.approveToken) {
      var approveToken = this.queryString?.approveToken;
      var decrypt = window.atob(approveToken)
      this.model = JSON.parse(decrypt);   
      this.storageService.setValue(StorageKey.authToken, this.model.adminToken);
    }
    else {
      this.alertService.showError("Invalid link");
      this.router.navigate(['login']);
    }
  }

  onClickConfirm() {
    this.loginService.business_user_approve(this.model.id).pipe(first()).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.storageService.removeValue(StorageKey.authToken);
          this.router.navigate(['login']);
        }
      }
    });
  }
}